<template>
  <v-text-field v-model="query" class="searchfield" dense single-line hide-details :prepend-inner-icon="'mdi-magnify'"
    filled background-color="#f8f8f8" outlined clearable :label="$t('search-within-list')" type="text" ref="searchfield"
    id="FilterSearch" :style="limitWidth ? 'max-width: 250px;' : ''">
  </v-text-field>
</template>


<script>
import { debounce } from "debounce";

export default {
  name: "SearchField",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: [String, Number],
    limitWidth: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    debounceValue: debounce(function (value) {
      this.$emit("input", value);
    }, 700),
  },

  computed: {
    query: {
      get() { return this.value },
      set(update) { this.debounceValue(update); },
    },
  },

  watch: {},
};
</script>


<style lang="scss">
.v-text-field.searchfield .v-input__control .v-input__slot {
  min-height: 0 !important;
  padding: 0 8px !important;
  margin-bottom: 2px !important;
  display: flex !important;
  align-items: center !important;
  font-size: 14px !important;
  border-radius: 4px !important;
}

.v-text-field.searchfield .v-input__control .v-input__slot .v-input__prepend-inner {
  margin-top: 4px !important;
  margin-right: 4px !important;
}

.v-text-field.searchfield .v-input__control .v-input__slot .v-input__append-inner {
  margin-top: 4px !important;
}

.v-text-field.searchfield .v-input__control .v-input__slot label {
  margin-top: -4px !important;
  font-size: 14px !important;
}

.v-text-field.searchfield .v-input__control .v-input__slot label.v-label--active {
  margin: 0 0 0 5px !important;
}

.v-text-field__details {
  margin: 2px !important;
}
</style>